import { Check } from 'lucide-react';
import React from 'react';

interface StepIndicatorProps {
  steps: { id: string; label: string }[];
  currentStep: number;
  onStepClick?: (stepIndex: number) => void;
}

export function StepIndicator({ steps, currentStep, onStepClick }: StepIndicatorProps) {
  return (
    <div className="flex items-center justify-center mb-8">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isCurrent = index === currentStep;
        const canClick = onStepClick && index <= currentStep;

        return (
          <React.Fragment key={step.id}>
            <button
              type="button"
              onClick={() => canClick && onStepClick?.(index)}
              disabled={!canClick}
              className={`flex flex-col items-center group ${canClick ? 'cursor-pointer' : 'cursor-default'}`}
            >
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all ${
                  isCompleted
                    ? 'bg-green-600 text-white'
                    : isCurrent
                    ? 'bg-[#9B1421] text-white ring-4 ring-[#9B1421]/30'
                    : 'bg-[#504A4A] text-[#A9A3A3]'
                } ${canClick ? 'hover:scale-110' : ''}`}
              >
                {isCompleted ? <Check size={20} /> : index + 1}
              </div>
              <span
                className={`text-xs mt-2 font-medium whitespace-nowrap ${
                  isCurrent ? 'text-[#EBFFEE]' : isCompleted ? 'text-green-500' : 'text-[#A9A3A3]'
                }`}
              >
                {step.label}
              </span>
            </button>
            {index < steps.length - 1 && (
              <div
                className={`w-12 sm:w-20 h-1 mx-2 rounded ${
                  index < currentStep ? 'bg-green-600' : 'bg-[#504A4A]'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

